export default __webpack_public_path__ + "static/media/obs_import.da9e3dfc.xlsx";